const InstagramIcon = () => {
  return <img style={{ height: '25px' }} alt="" src="/images/instagram.svg" />;
};

InstagramIcon.displayName = 'InstagramIcon';

export default InstagramIcon;
